Ext.define('SA.view.SessionExpiredPopup', {
    alias: 'widget.session-expired-popup',
    extend: 'SA.view.SimpleContainer',

    autoShow: true,
    cls: 'sa-session-expired-popup',
    floating: true,
    modal: true,
    plugins: 'sa-viewport-constrained-auto-center',

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-session-expired-popup-header',
            itemId: 'header',

            items: [
                {
                    xtype: 'component',
                    cls: 'sa-session-expired-popup-title',
                    html: 'Session Expired'
                }, {
                    xtype: 'close-button',
                    closeAction: 'destroyAndLogout'
                }
            ]
        }, {
            xtype: 'component',
            cls: 'sa-session-expired-popup-body',
            itemId: 'body',

            html: [
                '<svg class="sa-session-expired-popup-info-svg"><use href="#sa-icon-map-info"></use></svg>',
                '<div>',
                    'Your session has expired due to inactivity.<br><br>You will need to sign in again to continue using SimplyAnalytics.',
                '</div>'
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-session-expired-popup-footer',

            items: [
                {
                    xtype: 'sa-button',
                    itemId: 'goToLoginPageBtn',
                    text: 'Go to login page'
                }
            ]
        }
    ],

    initEvents() {
        this.callParent();

        this.down('#goToLoginPageBtn').on('click', this.destroyAndLogout, this);
    },

    destroyAndLogout() {
        this.destroy();

        SA.logout();
    }
});